import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Route, Link} from 'react-router-dom'

class NavLinkItem extends Component {
    static propTypes = {
        to: PropTypes.string.isRequired,
        exact: PropTypes.bool,
        className: PropTypes.string,
        activeClassName: PropTypes.string,
        children: PropTypes.node.isRequired,
    };
    static defaultProps = {};
    state = {};

    render() {
        const {to, exact, className, activeClassName, children, ...props} = this.props;
        return (
            <Route path={to} exact={exact} children={({match}) => (
                <li className={`${className} ${match ? activeClassName : ''}`}>
                    <Link to={to} {...props}>{children}</Link>
                </li>
            )}/>
        );
    }
}

export default NavLinkItem;


// WEBPACK FOOTER //
// ./src/components/NavLinkItem.js